import WhatsappTemplatesAPI from '../../api/whatsappTemplates';

const UNSUPPORTED_COMPONENT_TYPES = [
  'LIST',
  'PRODUCT',
  'CATALOG',
  'CALL_PERMISSION_REQUEST',
];

const state = {
  records: [],
  pickerRecords: [],
  meta: { total_count: 0, current_page: 1 },
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
  },
};

const getters = {
  getTemplates: _state => _state.records,
  getMeta: _state => _state.meta,
  getUIFlags: _state => _state.uiFlags,
  getPickerTemplates: _state =>
    _state.pickerRecords.filter(template => {
      if (template.category === 'AUTHENTICATION') return false;
      return !template.components.some(
        c =>
          UNSUPPORTED_COMPONENT_TYPES.includes(c.type) ||
          (c.type === 'HEADER' && c.format === 'LOCATION')
      );
    }),
};

const mutations = {
  SET_TEMPLATES(state, { data, meta }) {
    state.records = data;
    state.meta = meta;
  },
  SET_PICKER_TEMPLATES(state, data) {
    state.pickerRecords = data;
  },
  ADD_TEMPLATE(state, template) {
    state.records.unshift(template);
    state.meta.total_count += 1;
  },
  UPDATE_TEMPLATE(state, updated) {
    const index = state.records.findIndex(t => t.id === updated.id);
    if (index !== -1) state.records.splice(index, 1, updated);
  },
  REMOVE_TEMPLATE(state, templateId) {
    state.records = state.records.filter(t => t.id !== templateId);
    state.meta.total_count = Math.max(0, state.meta.total_count - 1);
  },
  SET_UI_FLAG(state, flags) {
    state.uiFlags = { ...state.uiFlags, ...flags };
  },
};

const actions = {
  fetch: async ({ commit }, { inboxId, params = {} }) => {
    commit('SET_UI_FLAG', { isFetching: true });
    try {
      const { data } = await WhatsappTemplatesAPI.getTemplates(inboxId, params);
      commit('SET_TEMPLATES', { data: data.data, meta: data.meta });
    } finally {
      commit('SET_UI_FLAG', { isFetching: false });
    }
  },

  syncAndFetch: async ({ dispatch }, { inboxId }) => {
    await WhatsappTemplatesAPI.syncTemplates(inboxId).catch(() => {});
    await dispatch('fetch', { inboxId });
  },

  fetchForPicker: async ({ commit }, { inboxId, name }) => {
    const params = { status: 'APPROVED', per_page: 100 };
    if (name) params.name = name;
    const { data } = await WhatsappTemplatesAPI.getTemplates(inboxId, params);
    commit('SET_PICKER_TEMPLATES', data.data);
  },

  create: async ({ commit }, { inboxId, templateData }) => {
    commit('SET_UI_FLAG', { isCreating: true });
    try {
      const { data } = await WhatsappTemplatesAPI.createTemplate(
        inboxId,
        templateData
      );
      commit('ADD_TEMPLATE', data);
      return data;
    } finally {
      commit('SET_UI_FLAG', { isCreating: false });
    }
  },

  update: async ({ commit }, { inboxId, templateId, templateData }) => {
    commit('SET_UI_FLAG', { isUpdating: true });
    try {
      const { data } = await WhatsappTemplatesAPI.updateTemplate(
        inboxId,
        templateId,
        templateData
      );
      commit('UPDATE_TEMPLATE', data);
      return data;
    } finally {
      commit('SET_UI_FLAG', { isUpdating: false });
    }
  },

  destroy: async ({ commit }, { inboxId, templateId }) => {
    commit('SET_UI_FLAG', { isDeleting: true });
    try {
      await WhatsappTemplatesAPI.deleteTemplate(inboxId, templateId);
      commit('REMOVE_TEMPLATE', templateId);
    } finally {
      commit('SET_UI_FLAG', { isDeleting: false });
    }
  },

  updateStatus: ({ commit }, { id, status, rejection_reason }) => {
    commit('UPDATE_TEMPLATE', { id, status, rejection_reason });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
